export default "__VITE_ASSET__CAyukSV7__"